import { createSlice } from "@reduxjs/toolkit";
import { IDepartmentSlice } from "../../../models/master/department";


const initialDepartmentState: IDepartmentSlice = {
  departments: undefined,
  department: undefined,
};

const departmentSlice = createSlice({
  name: "department",
  initialState: initialDepartmentState,
  reducers: {
    setDepartments: (state, action: { payload: any }) => {
      state.departments = action.payload;
    },
    setDepartment: (state, action: { payload: any }) => {
      state.department = action.payload;
    },
  },
});

export const { setDepartments, setDepartment } =
  departmentSlice.actions;

const departmentReducer = departmentSlice.reducer;

export type departmentState = ReturnType<typeof departmentReducer>;

export default departmentReducer;
